import { render, staticRenderFns } from "./FlagSelector.vue?vue&type=template&id=3010d856&scoped=true&"
import script from "./FlagSelector.vue?vue&type=script&lang=ts&"
export * from "./FlagSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3010d856",
  null
  
)

export default component.exports